import { render, staticRenderFns } from "./table-data-1.vue?vue&type=template&id=a6a913e0&scoped=true"
import script from "./table-data-1.vue?vue&type=script&lang=js"
export * from "./table-data-1.vue?vue&type=script&lang=js"
import style0 from "./table-data-1.vue?vue&type=style&index=0&id=a6a913e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a913e0",
  null
  
)

export default component.exports